// Fichier: src/components/Drawer.js
// Description: Composant réutilisable pour afficher un panneau latéral (drawer)

import React, { useEffect } from 'react';
import './Drawer.css'; // Nous allons créer ce fichier CSS juste après

/**
 * Composant Drawer - Affiche un panneau latéral qui apparaît depuis la droite
 *
 * @param {boolean} isOpen - Indique si le drawer est ouvert
 * @param {function} onClose - Fonction appelée quand le drawer se ferme
 * @param {string} title - Titre principal du drawer
 * @param {React.ReactNode} children - Contenu à afficher dans le drawer
 * @param {string} className - Classes CSS additionnelles (optionnel)
 * @returns {React.ReactNode}
 */
const Drawer = ({ isOpen, onClose, title, children, className = '' }) => {
  // Empêcher le défilement du fond quand le drawer est ouvert
  useEffect(() => {
    if (isOpen) {
      // Pour desktop, on veut juste empêcher le scroll sur mobile
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      // Restaurer le scroll quand on ferme le drawer
      document.body.style.overflow = 'auto';
    }

    // Nettoyer en sortant
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  // Gérer la fermeture quand on clique à l'extérieur (sur mobile)
  const handleBackdropClick = e => {
    // Ferme uniquement si on clique sur le fond et pas sur le contenu
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className={`drawer-container ${isOpen ? 'open' : ''}`}
      onClick={handleBackdropClick}
    >
      <div className={`drawer-content ${className}`}>
        <div className="drawer-header">
          <h2 className="drawer-title">{title}</h2>
          <button className="drawer-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="drawer-body">{children}</div>
      </div>
    </div>
  );
};

export default Drawer;
